




















import { Component, Vue, Prop } from "vue-property-decorator";
import VideoBox from "@/components/room/VideoBox.vue";

import * as twilio from "twilio-video";

@Component({ components: { VideoBox } })
export default class VideoParticipants extends Vue {
  @Prop({ required: true })
  remoteParticipants!: twilio.RemoteParticipant[];

  @Prop({ default: null })
  localParticipant!: twilio.LocalParticipant | null;

  @Prop({ default: "short" })
  height!: "tall" | "short";

  @Prop({ default: null })
  highlight!: string | null;
}
